module.exports = __webpack_public_path__ + "img/engagement.e65b5d36.svg";